<template>
  <div class="alternative-login">
    <button
      v-for="button in buttons"
      :key="button.key"
      class="btn-secondary"
      :class="{ 'btn-with-indicator': button.withIndicator }"
      :t_label="`btn_emp2_AlternativeLogin_${button.key}`"
      @click="handleClick(button.key)"
    >
      <span class="btn-text">{{ button.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AlternativeLoginButtons',
  props: {
    buttons: {
      type: Array,
      required: true,
      validator(buttons) {
        return buttons.every(btn => btn.key && btn.label);
      }
    }
  },
  methods: {
    handleClick(key) {
      this.$emit('switch', key);
    }
  }
};
</script>

<style scoped>
.alternative-login {
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  display: inline-flex;
  margin: 0;
  padding: 0;
}

.btn-secondary {
  align-self: stretch;
  height: 42px;
  padding: 0 24px;
  border-radius: 999px;
  outline: 1px rgba(0, 0, 0, 0.60) solid;
  outline-offset: -1px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  background: white !important;
  background-color: white !important;
  border: none !important;
  cursor: pointer;
  transition: all 0.2s;
  box-sizing: border-box;
}

.btn-secondary:hover {
  background: rgba(0, 0, 0, 0.03) !important;
  background-color: rgba(0, 0, 0, 0.03) !important;
  outline-color: rgba(0, 0, 0, 0.60);
}

.btn-secondary:active,
.btn-secondary:focus {
  background: rgba(0, 0, 0, 0.03) !important;
  background-color: rgba(0, 0, 0, 0.03) !important;
  outline-color: rgba(0, 0, 0, 0.60);
}

.btn-text {
  text-box-trim: trim-both;
  text-box-edge: cap alphabetic;
  justify-content: center;
  display: flex;
  flex-direction: column;
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  line-height: 14px;
  word-wrap: break-word;
}

@media (max-width: 480px) {
  /* 移动端：长文案（含邮箱/手机号）允许换行折叠，避免溢出 */
  .alternative-login .btn-text {
    white-space: normal;
    word-break: break-word;
    text-align: center;
    line-height: 18.2px;
    align-items: center;
  }
}
</style>

<!-- 特殊场景样式和全局覆盖 -->
<style>
.login-step-otp .alternative-login {
  margin: 0;
  gap: 0;
}

/* 覆盖全局红色背景样式 */
.alternative-login .btn-secondary {
  background: white !important;
  background-color: white !important;
  border: none !important;
  color: rgba(0, 0, 0, 0.80) !important;
}

.alternative-login .btn-secondary:hover {
  background: rgba(0, 0, 0, 0.03) !important;
  background-color: rgba(0, 0, 0, 0.03) !important;
  color: rgba(0, 0, 0, 0.80) !important;
}

.alternative-login .btn-secondary:active,
.alternative-login .btn-secondary:focus {
  background: rgba(0, 0, 0, 0.03) !important;
  background-color: rgba(0, 0, 0, 0.03) !important;
  color: rgba(0, 0, 0, 0.80) !important;
}
</style>

